export default __webpack_public_path__ + "static/5-b78e213daca0d1df684a95767907a796.png";